import { Label } from '@creanizer/ui'
import { Textarea } from '@creanizer/ui'
import type { DungeonInput } from '@creanizer/types'

interface DungeonFormQuickProps {
  input: DungeonInput
  onChange: (input: DungeonInput) => void
}

export function DungeonFormQuick({ input, onChange }: DungeonFormQuickProps) {
  return (
    <div className="space-y-4">
      <div>
        <Label>ダンジョンの概要</Label>
        <Textarea
          value={input.theme || ''}
          onChange={(e) => onChange({ ...input, theme: e.target.value })}
          placeholder="どんなダンジョンを生成しますか？&#10;&#10;例：&#10;・古代の魔法文明が残した試練の塔&#10;・ドラゴンが守る宝物庫&#10;・地下に広がる巨大な迷宮都市&#10;・時空が歪んだ不思議なダンジョン"
          rows={8}
          className="resize-none"
        />
        <p className="text-sm text-muted-foreground mt-2">
          自由な文章でダンジョンのイメージを記述してください。AIが詳細を補完して生成します。
        </p>
      </div>
      
      <div>
        <Label>追加の要望（オプション）</Label>
        <Textarea
          value={input.additionalSettings || ''}
          onChange={(e) => onChange({ ...input, additionalSettings: e.target.value })}
          placeholder="特に含めたい要素があれば記述してください&#10;&#10;例：&#10;・特定の敵やボスを配置したい&#10;・謎解き要素を多めにしたい&#10;・探索の自由度を高くしたい"
          rows={4}
          className="resize-none"
        />
      </div>
    </div>
  )
}